import { useEffect, useState } from 'react';
import { fetchWindowsPaths } from './references-api';

// a model's place on the share does not change while the page is open
const known = new Map<string, string | null>();
const pending = new Set<string>();
const MAX_VALUES = 500;

export function resetWindowsPaths(): void {
    known.clear();
    pending.clear();
}

// value -> path; a value missing from the result is still being asked for
export function useWindowsPaths(values: string[]): Record<string, string | null> {
    const key = Array.from(new Set(values)).sort().join('\n');
    const [, setVersion] = useState(0);

    useEffect(() => {
        let cancelled = false;
        const wanted = key ? key.split('\n') : [];
        const missing = wanted.filter((value) => !known.has(value) && !pending.has(value)).slice(0, MAX_VALUES);
        if (!missing.length) return undefined;
        missing.forEach((value) => pending.add(value));
        fetchWindowsPaths(missing).then((paths) => {
            missing.forEach((value) => known.set(value, paths[value] ?? null));
        }).catch(() => {
            // asked again next time the list changes
        }).finally(() => {
            missing.forEach((value) => pending.delete(value));
            if (!cancelled) setVersion((version) => version + 1);
        });
        return () => { cancelled = true; };
    }, [key]);

    const result: Record<string, string | null> = {};
    for (const value of key ? key.split('\n') : []) {
        if (known.has(value)) result[value] = known.get(value) as string | null;
    }
    return result;
}
